<span class="feature-flags-title gea-font-heading-24">Feature Flags</span>

<div class="feature-flags-card">
  @if (allFlags.length) {
    <form class="feature-flags-grid" [formGroup]="flagsForm">
      @for (flag of allFlags; track flag.id) {
        <div class="feature-flag-cell">
          <span class="feature-flag-label gea-font-heading-16">
            {{ flag.name }}
          </span>
          <geaui-toggle-v3
            [id]="flag.id"
            [formGroup]="flagsForm"
            [value]="flagsForm.get(flag.id)?.value"
            [flex]="false"
            [loading]="false" />
        </div>
      }
    </form>
  } @else {
    <div class="feature-flags-grid">
      @for (_item of skeletonItems; track $index) {
        <div class="feature-flag-cell">
          <p-skeleton width="8rem" height="1rem" borderRadius="0.25rem" />
          <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem" />
        </div>
      }
    </div>
  }
</div>
